import NotFound from 'govbr.frontend.policy/components/Errors/NotFound/NotFound';

export default NotFound;
